module.exports = __webpack_public_path__ + "img/waistband width.b289cc90.png";